import { z } from 'zod';
import { AnalysisLensSchema, DomainSchema } from './enums';
import { PlanIdSchema } from './ids';
import { NonEmptyStringSchema } from './primitives';

/**
 * The plan seam (docs/DECISIONS.md ZD-012).
 *
 * `AnalysisPlan` is the exact shape a planner worker would emit, whether it is
 * produced by deterministic rules (MVP) or by a bounded planner-plus-policy-
 * engine (post-MVP). The orchestrator consumes the plan either way and never
 * branches on canonical-model content — it branches on the plan.
 */
export const AnalysisPlanSchema = z.object({
  plan_id: PlanIdSchema,
  domains: z.array(DomainSchema).min(1),
  lenses: z.array(AnalysisLensSchema),
  reasoning: z.array(NonEmptyStringSchema),
  estimated_cost_band: z.enum(['low', 'medium', 'high']),
  requires_human_confirmation: z.boolean(),
  /** Which kind of selector produced this plan — a rules table today, a bounded planner later. */
  selector: z.enum(['deterministic', 'planner']),
});
export type AnalysisPlan = z.infer<typeof AnalysisPlanSchema>;
